import { DocumentNode } from 'graphql-compose/lib/graphql';

import { onboardingQuery, onboardingRouteData } from '@ui/routes/Membership/OnboardingHelpers';

import { FlowIdTypes, GetRouteData } from '@folx-types/flow';

type Routes = {
	[Type in FlowIdTypes]: {
		query?: DocumentNode;
		routeData?: GetRouteData;
	};
};
export const routes: Routes = {
	user_onboarding: {
		query: onboardingQuery,
		routeData: onboardingRouteData,
	},
};
